import { render, staticRenderFns } from "./Notification.vue?vue&type=template&id=afb5a7b8&"
import script from "./Notification.vue?vue&type=script&lang=js&"
export * from "./Notification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\RobertWiberg\\source\\repos\\server-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('afb5a7b8')) {
      api.createRecord('afb5a7b8', component.options)
    } else {
      api.reload('afb5a7b8', component.options)
    }
    module.hot.accept("./Notification.vue?vue&type=template&id=afb5a7b8&", function () {
      api.rerender('afb5a7b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Messages/Notification.vue"
export default component.exports